import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import "./owed-tuition.scss";
import { SocketContext } from "../../../../app/socket";
import { iconStyle } from "../../../../utils/generalUtils";
import { Link } from "react-router-dom";
import { BiPrinter } from "react-icons/bi";
import { useReactToPrint } from "react-to-print";

const monthNamesGreek = [
  "Ιανουάριος",
  "Φεβρουάριος",
  "Μάρτιος",
  "Απρίλιος",
  "Μάιος",
  "Ιούνιος",
  "Ιούλιος",
  "Αύγουστος",
  "Σεπτέμβριος",
  "Οκτώβριος",
  "Νοέμβριος",
  "Δεκέμβριος",
];

const OwedTuition = () => {
  const socketContext = useContext(SocketContext);
  const [totlaOwedTuition, setTotalOwedTuition] = useState(0);
  const htmlRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => htmlRef.current, // Reference to the element you want to print
    documentTitle: "Χρωστούμενα Δίδακτρα", // Optional: Title for the print document
  });

  const [missingTuition, setMissingTuition] = useState([]);
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // JavaScript months are 0-based.
  const currentYear = now.getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const generatePeriodOptions = () => {
    const options = [];
    const startYear = 2024;
    const startMonth = 9; // September
    const endYear = 2025;
    const endMonth = 9; // September

    let currentYear = startYear;
    let currentMonth = startMonth;

    while (
      currentYear < endYear ||
      (currentYear === endYear && currentMonth <= endMonth)
    ) {
      options.push({
        month: currentMonth,
        year: currentYear,
        label: `${monthNamesGreek[currentMonth - 1]} ${currentYear}`,
      });

      currentMonth++;
      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear++;
      }
    }

    return options;
  };

  const periodOptions = generatePeriodOptions();

  // Check if the current month/year is in the generated list.
  const defaultPeriod =
    periodOptions.find(
      (option) => option.month === currentMonth && option.year === currentYear
    ) || periodOptions[0];

  const [selectedPeriod, setSelectedPeriod] = useState(defaultPeriod);

  useEffect(() => {
    const cleanUpGetOwedTuition = getOwedTuition();
    return () => {
      cleanUpGetOwedTuition();
    };
  }, [selectedPeriod]);

  const getOwedTuition = () => {
    const args = {
      month: selectedPeriod.month,
      year: selectedPeriod.year,
    };

    const getOwedTuitionListener = (data) => {
      console.log(data);
      if (!data) {
        setMissingTuition([]);
      }
      // Step 1: Group by user_id
      const userMap = new Map();

      data.forEach((item) => {
        const {
          user_id,
          first_name,
          last_name,
          profile_picture,
          outstanding,
          price_list_title,
          student_tuition_id,
        } = item;

        // If there is no price_list_title (or it is null/undefined), use 'Γενικά Δίδακτρα'
        const finalTitle = price_list_title || "Γενικά Δίδακτρα";

        // Convert outstanding to a number
        const outstandingNumber = parseFloat(outstanding);

        // Check if we already have this user_id in the map
        if (!userMap.has(user_id)) {
          // Initialize user object
          userMap.set(user_id, {
            user_id,
            first_name,
            last_name,
            profile_picture,
            total_outstanding: 0,
            tuitions: [],
          });
        }

        // Retrieve the user object from the map
        const userObj = userMap.get(user_id);

        // Push the tuition item
        userObj.tuitions.push({
          student_tuition_id,
          price_list_title: finalTitle,
          outstanding: outstandingNumber,
        });

        // Update total outstanding
        userObj.total_outstanding += outstandingNumber;
      });

      // Step 2: Convert map values to an array
      const groupedArray = Array.from(userMap.values());

      // Now you have a list of unique users, each with a sum of outstanding
      // and a list of tuitions. Let's set it to state.
      let total = 0;
      groupedArray.map((item) => {
        total += parseFloat(item.total_outstanding);
      });
      setTotalOwedTuition(total);

      setMissingTuition(groupedArray);
    };

    socketContext.socket.on("owedTuition", getOwedTuitionListener);
    socketContext.socket.emit("getOwedTuition", args);

    return () => {
      socketContext.socket.off("owedTuition", getOwedTuitionListener);
    };
  };

  const generateUserRows = () => {
    console.log("missing tuition");
    console.log(missingTuition);
    return missingTuition.map((tuition) => {
      return `
        <tr>
          <td width="20%" style="padding: 10px; word-break: break-word; border-top: 3px solid #dddddd; border-right: 3px solid #dddddd; border-bottom: 3px solid #dddddd; border-left: 3px solid #dddddd;">
            ${tuition.first_name} ${tuition.last_name}
          </td>
          <td width="20%" style="padding: 10px; word-break: break-word; border-top: 3px solid #dddddd; border-right: 3px solid #dddddd; border-bottom: 3px solid #dddddd; border-left: 3px solid #dddddd;">
            ${tuition.title}
          </td>
          <td width="20%" style="padding: 10px; word-break: break-word; border-top: 3px solid #dddddd; border-right: 3px solid #dddddd; border-bottom: 3px solid #dddddd; border-left: 3px solid #dddddd;">
            ${tuition.amount}
          </td>
          <td width="20%" style="padding: 10px; word-break: break-word; border-top: 3px solid #dddddd; border-right: 3px solid #dddddd; border-bottom: 3px solid #dddddd; border-left: 3px solid #dddddd;">
            ${tuition.amount}
          </td>
          <td width="20%" style="padding: 10px; word-break: break-word; border-top: 3px solid #dddddd; border-right: 3px solid #dddddd; border-bottom: 3px solid #dddddd; border-left: 3px solid #dddddd;">
            ${tuition.amount} €
          </td>
        </tr>
      `;
    });
  };

  const populatePrintOwed = () => {
    return missingTuition.map((user) => {
      const { first_name, last_name, total_outstanding, tuitions } = user;
      let html = ``;
      tuitions.map((t) => {
        html += `
          <div key={t.student_tuition_id} className="item-details__item">
            <span className="item-details__label">${t.price_list_title}:</span>
            <span className="item-details__title">
              ${t.outstanding.toFixed(2)}€
            </span>
          </div>`;
      });

      return `<tr>
          <td width="33%" style="padding: 10px; word-break: break-word; border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">${last_name} ${first_name}</td>
          <td width="33%" style="padding: 10px; word-break: break-word; border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">${total_outstanding.toFixed(
            2
          )}€</td>
          <td width="33%" style="padding: 10px; word-break: break-word;   border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">${html}</td>
        </tr>`;
    });
  };

  let htmlTemplate = `
  <!DOCTYPE html>
  <html
    xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office"
    lang="en"
  >
    <head>
      <title></title>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <!--[if mso
        ]><xml
          ><o:OfficeDocumentSettings
            ><o:PixelsPerInch>96</o:PixelsPerInch
            ><o:AllowPNG /></o:OfficeDocumentSettings></xml
      ><![endif]-->
      <!--[if !mso]><!-->
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900"
        rel="stylesheet"
        type="text/css"
      />
      <!--<![endif]-->
      <style>
        * {
          box-sizing: border-box;
        }
  
        body {
          margin: 0;
          padding: 0;
        }
  
        a[x-apple-data-detectors] {
          color: inherit !important;
          text-decoration: inherit !important;
        }
  
        #MessageViewBody a {
          color: inherit;
          text-decoration: none;
        }
  
        p {
          line-height: inherit;
        }
  
        .desktop_hide,
        .desktop_hide table {
          mso-hide: all;
          display: none;
          max-height: 0px;
          overflow: hidden;
        }
  
        .image_block img + div {
          display: none;
        }
  
        sup,
        sub {
          line-height: 0;
          font-size: 75%;
        }
  
        @media (max-width: 768px) {
          .desktop_hide table.icons-inner {
            display: inline-block !important;
          }
  
          .icons-inner {
            text-align: center;
          }
  
          .icons-inner td {
            margin: 0 auto;
          }
  
          .mobile_hide {
            display: none;
          }
  
          .row-content {
            width: 100% !important;
          }
  
          .stack .column {
            width: 100%;
            display: block;
          }
  
          .mobile_hide {
            min-height: 0;
            max-height: 0;
            max-width: 0;
            overflow: hidden;
            font-size: 0px;
          }
  
          .desktop_hide,
          .desktop_hide table {
            display: table !important;
            max-height: none !important;
          }
        }
      </style>
      <!--[if mso
        ]><style>
          sup,
          sub {
            font-size: 100% !important;
          }
          sup {
            mso-text-raise: 10%;
          }
          sub {
            mso-text-raise: -10%;
          }
        </style>
      <![endif]-->
    </head>
  
    <body
      class="body"
      style="
        background-color: #ffffff;
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: none;
        text-size-adjust: none;
      "
    >
      <table
        class="nl-container"
        width="100%"
        border="0"
        cellpadding="0"
        cellspacing="0"
        role="presentation"
        style="
          mso-table-lspace: 0pt;
          mso-table-rspace: 0pt;
          background-color: #ffffff;
        "
      >
        <tbody>
          <tr>
            <td>
              <table
                class="row row-1"
                align="center"
                width="100%"
                border="0"
                cellpadding="0"
                cellspacing="0"
                role="presentation"
                style="mso-table-lspace: 0pt; mso-table-rspace: 0pt"
              >
                <tbody>
                  <tr>
                    <td>
                      <table
                        class="row-content stack"
                        align="center"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        role="presentation"
                        style="
                          mso-table-lspace: 0pt;
                          mso-table-rspace: 0pt;
                          border-radius: 0;
                          color: #000000;
                          width: 900px;
                          margin: 0 auto;
                        "
                        width="900"
                      >
                        <tbody>
                          <tr>
                            <td
                              class="column column-1"
                              width="75%"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                padding-bottom: 5px;
                                padding-top: 5px;
                                vertical-align: middle;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                            >
                              <table
                                class="heading_block block-1"
                                width="100%"
                                border="0"
                                cellpadding="10"
                                cellspacing="0"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                "
                              >
                                <tr>
                                  <td class="pad">
                                    <h1
                                      style="
                                        margin: 0;
                                        color: #7747ff;
                                        direction: ltr;
                                        font-family: 'Montserrat', 'Trebuchet MS',
                                          'Lucida Grande', 'Lucida Sans Unicode',
                                          'Lucida Sans', Tahoma, sans-serif;
                                        font-size: 38px;
                                        font-weight: 700;
                                        letter-spacing: normal;
                                        line-height: 120%;
                                        text-align: center;
                                        margin-top: 0;
                                        margin-bottom: 0;
                                        mso-line-height-alt: 45.6px;
                                      "
                                    >
                                    ${
                                      window.location.hostname.includes(
                                        "oramapaideias"
                                      )
                                        ? `<img src="https://oramapaideias.edupal.gr/resources/logos/orama_paideias.png" style="display: block; height: auto; border: 0; max-width: 135px; width: 100%;" width="135" alt="Logo" title="Logo">`
                                        : `<img src="https://md.edupal.gr/resources/logos/edupal.png" style="display: block; height: auto; border: 0; max-width: 135px; width: 100%;" width="135" alt="Logo" title="Logo">`
                                    }
                                    </h1>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td
                              class="column column-2"
                              width="25%"
                              style="
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                font-weight: 400;
                                text-align: left;
                                padding-bottom: 5px;
                                padding-top: 5px;
                                vertical-align: middle;
                                border-top: 0px;
                                border-right: 0px;
                                border-bottom: 0px;
                                border-left: 0px;
                              "
                            >
                              <table
                                class="paragraph_block block-1"
                                width="100%"
                                border="0"
                                cellpadding="10"
                                cellspacing="0"
                                role="presentation"
                                style="
                                  mso-table-lspace: 0pt;
                                  mso-table-rspace: 0pt;
                                  word-break: break-word;
                                "
                              >
                                <tr>
                                  <td class="pad">
                                    <div
                                      style="
                                        color: #101112;
                                        direction: ltr;
                                        font-family: 'Montserrat', 'Trebuchet MS',
                                          'Lucida Grande', 'Lucida Sans Unicode',
                                          'Lucida Sans', Tahoma, sans-serif;
                                        font-size: 16px;
                                        font-weight: 400;
                                        letter-spacing: 0px;
                                        line-height: 120%;
                                        text-align: center;
                                        mso-line-height-alt: 19.2px;
                                      "
                                    >
                                      <p style="margin: 0; margin-bottom: 16px">
                                        <strong>Χρωστόυμενα Δίδακτρα: </strong>
                                        <strong>${totlaOwedTuition}</strong>
                                      </p>
                                        <p style="margin: 0; margin-bottom: 16px">
                                        <strong>${
                                          monthNamesGreek[
                                            selectedPeriod.month - 1
                                          ]
                                        }</strong>
                                           <strong>${
                                             selectedPeriod.year
                                           }</strong>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                              <table class="row row-5" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                              <tbody>
                                <tr>
                                  <td>
                                    <table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; color: #000000; width: 900px; margin: 0 auto;" width="900">
                                      <tbody>
                                        <tr>
                                          <td class="column column-1" width="100%" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; padding-bottom: 5px; padding-top: 5px; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;">
                                            <table class="heading_block block-1" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                                              <tr>
                                                <td class="pad">
                                                  <h1 style="margin: 0; color: #000000; direction: ltr; font-family: 'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif; font-size: 20px; font-weight: 400; letter-spacing: normal; line-height: 120%; text-align: left; margin-top: 0; margin-bottom: 0; mso-line-height-alt: 24px;"><span class="tinyMce-placeholder" style="word-break: break-word;">Μαθητές:</span></h1>
                                                </td>
                                              </tr>
                                            </table>
                                            <table class="table_block block-2" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                                              <tr>
                                                <td class="pad">
                                                  <table style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-collapse: collapse; width: 100%; table-layout: fixed; direction: ltr; background-color: transparent; font-family: 'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif; font-weight: 400; color: #101112; text-align: left; letter-spacing: 0px; word-break: break-all;" width="100%">
                                                    <thead style="vertical-align: top; background-color: #f2f2f2; color: #101112; font-size: 14px; line-height: 120%; text-align: center;">
                                                     <tr>
                                                        <th width="33%" style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">Μαθητής<br></th>
                                                        <th width="33%" style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">Σύνολικο Ποσό Οφειλής<br></th>
                                                        <th width="33%" style="padding: 10px; word-break: break-word; font-weight: 700; border-top: 1px solid #dddddd; border-right: 1px solid #dddddd; border-bottom: 1px solid #dddddd; border-left: 1px solid #dddddd;">Χρωστούμενα Δίδακτρα<br></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody style="vertical-align: top; font-size: 16px; line-height: 120%;">
                                                    ${populatePrintOwed()}
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- End -->
    </body>
  </html>  
  `;

  return (
    <div className="owed-tuition">
      <div className="html-container" ref={htmlRef}>
        <div dangerouslySetInnerHTML={{ __html: htmlTemplate }} />
      </div>
      <div className="owed-tuition__header">
        <span className="owed-tuition__header-title">Χρωστούμενα δίδακτρα</span>
        <div className="owed-tuition__controls">
          {/* Combined Month-Year Dropdown */}
          <select
            className="input"
            value={`${selectedPeriod.month}-${selectedPeriod.year}`}
            onChange={(e) => {
              // Expected value format is "month-year" (for example "9-2024").
              const [month, year] = e.target.value.split("-").map(Number);
              setSelectedPeriod({
                month,
                year,
                label: `${monthNamesGreek[month - 1]} ${year}`,
              });
            }}
          >
            {periodOptions.map((option, idx) => (
              <option key={idx} value={`${option.month}-${option.year}`}>
                {option.label}
              </option>
            ))}
          </select>
          <div
            className="owed-tuition__controls-print"
            onClick={() => handlePrint()}
          >
            <BiPrinter
              style={iconStyle("transparent")}
              color={"#ccc"}
              size={30}
            />
          </div>
        </div>
      </div>
      <div className="owed-tuition__list">
        {missingTuition.map((user) => {
          const {
            user_id,
            first_name,
            last_name,
            profile_picture,
            total_outstanding,
            tuitions,
          } = user;
          return (
            <Link
              to={"/profile?user-id=" + user_id}
              key={user_id}
              className="owed-tuition__list-item"
            >
              <div className="item-profile">
                <div className="item-profile__img">
                  <img
                    src={
                      user.profile_picture
                        ? user.profile_picture
                        : "resources/student.png"
                    }
                    alt={"student"}
                  />
                </div>
                <div className="item-profile__name">
                  <span>{first_name}</span>
                  <span>{last_name}</span>
                </div>
              </div>

              <div className="item-owed">
                <span className="item-owed__label">Συνολικό Ποσό Οφειλής:</span>
                <span className="item-owed__title">
                  {total_outstanding.toFixed(2)}€
                </span>
              </div>

              <div className="item-details">
                {tuitions.map((t) => (
                  <div
                    key={t.student_tuition_id}
                    className="item-details__item"
                  >
                    <span className="item-details__label">
                      {t.price_list_title}:
                    </span>
                    <span className="item-details__title">
                      {t.outstanding.toFixed(2)}€
                    </span>
                  </div>
                ))}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default OwedTuition;
